export class DomainProductsDto {

    private key: string;
    private name: string;


    /**
     * Getter $key
     * @return {string}
     */
	public get $key(): string {
		return this.key;
    }


    /**
     * Getter $name
     * @return {string}
     */
	public get $name(): string {
		return this.name;
	}

    /**
     * Setter $key
     * @param {string} value
     */
	public set $key(value: string) {
		this.key = value;
	}

    /**
     * Setter $name
     * @param {string} value
     */
	public set $name(value: string) {
		this.name = value;
	}

	constructor(data: any) {
        this.key = data.key;
        this.name = data.name;
	}


}

